<!-- <div class="dual-cols">
  <div class="col left"> -->
    <page-sections [page]="page" [editMode]="editMode"></page-sections>
  <!-- </div>
  <div *ngIf="page?.sidebars?.data?.length > 0 || editMode" class="col right">
    <page-sidebars [page]="page" [editMode]="editMode"></page-sidebars>
  </div>
</div> -->
